import AuthProvider from "@forwardflow/context/AuthContext";
import { SentryRouteTracker } from "@forwardflow/helpers/utils";
import LocalStorage from "@forwardflow/services/LocalStorage";
import { Outlet, Navigate } from "react-router-dom";

const ProtectRoutes = () => {
  console.debug('🚀 ~ ProtectRoutes ~ ProtectRoutes:')
  const user = LocalStorage.get("access_token") !== null ? true : false;

  return user ? (
    <AuthProvider>
      <SentryRouteTracker />
      <Outlet />
    </AuthProvider>
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectRoutes;
